import { ReactNode } from 'react';
import { Alert, AlertTitle, Stack } from '@mui/material';
import { MessageTypes } from '../../../constants';

interface MessageProps {
  type?: MessageTypes;
  title?: string | ReactNode;
  body: string | ReactNode;
  onClose?: () => void;
}

const Message = ({ type = MessageTypes.INFO, title, body, onClose }: MessageProps) => (
  <Stack sx={{ width: '100%', textAlign: 'left' }}>
    <Alert variant="filled" severity={type} onClose={onClose}>
      {title && <AlertTitle>{title}</AlertTitle>}
      {body}
    </Alert>
  </Stack>
);

export default Message;
